import {UPDATE_POSTS_START, UPDATE_POSTS_SUCCESS, UPDATE_POSTS_ERROR} from "../../types";

export default function update_posts(state, action) {
  switch (action.type) {
    case UPDATE_POSTS_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case UPDATE_POSTS_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case UPDATE_POSTS_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return { ...state };
  }
}